import { REDUCE_PRODUCT_SETTINGS } from '../../constants/actions/policy';

export function reduceProductSettings(payload) {
    return {
        type: REDUCE_PRODUCT_SETTINGS,
        payload,
    };
}
